module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-day-fill-b77f51cb.svg";